import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import clsx from 'clsx';

import { useBannerStore } from '@/store/useBannerStore';
import { isMobileByUA } from '@/utils/ua';

import close from './close.png';
import styles from './index.module.less';

interface BannerProps {
  onClose?: () => void;
}

const Banner: React.FC<BannerProps> = ({ onClose }) => {
  const { isBannerVisible, initializeBannerState, closeBanner } = useBannerStore();
  const { t } = useTranslation();

  const handleClose = () => {
    closeBanner();
    onClose?.();
  };

  // 初始化banner状态
  useEffect(() => {
    initializeBannerState();
  }, [initializeBannerState]);

  const isMobile = isMobileByUA();

  if (!isBannerVisible) {
    return null;
  }

  return (
    <div id="global-banner" className={clsx(styles.banner, isMobile && styles.bannerMobile)}>
      <div className={styles.content}>
        <span className={styles.text}>
          {t('banner.windowsRelease')}
          <Link className={styles.link} to="/download">
            {t('banner.downloadLink')}
          </Link>
        </span>
        <button className={styles.closeButton} onClick={handleClose}>
          <img src={close} alt={t('banner.closeAlt')} className={styles.closeIcon} />
        </button>
      </div>
    </div>
  );
};

export default Banner;
